<script lang="ts">
  /**
   * Attachment chips (spec §11): forwarded originals first (`.chip.fwd`, re-attached server-side
   * through `fwdFrom`), then local files (`.chip` with name, size, remove).
   */
  import { t } from '$lib/i18n';
  import { formatSize } from '$lib/mail/format';
  import type { ForwardPart } from '$lib/types';
  import { tooltip } from '$lib/util/dom';
  import Icon from '../ui/Icon.svelte';

  let {
    files,
    fwd,
    onremove,
    onremovefwd,
  }: {
    files: readonly File[];
    fwd: readonly ForwardPart[];
    onremove: (index: number) => void;
    onremovefwd: (index: number) => void;
  } = $props();
</script>

{#if fwd.length}
  <div class="files">
    {#each fwd as part, i (part.part)}
      <span class="chip fwd">
        <Icon name="clip" size={13} />
        <span class="fname" dir="ltr">{part.filename}</span>
        {#if part.size}<small>{formatSize(part.size)}</small>{/if}
        <button type="button" aria-label={`${t('del')} ${part.filename}`} use:tooltip onclick={() => onremovefwd(i)}><Icon name="x" size={13} /></button>
      </span>
    {/each}
  </div>
{/if}
{#if files.length}
  <div class="files">
    {#each files as file, i (file)}
      <span class="chip">
        <Icon name="clip" size={13} />
        <span class="fname" dir="ltr">{file.name}</span>
        <small>{formatSize(file.size)}</small>
        <button type="button" aria-label={`${t('del')} ${file.name}`} use:tooltip onclick={() => onremove(i)}><Icon name="x" size={13} /></button>
      </span>
    {/each}
  </div>
{/if}

<style>
  /* ===== component: svelte-lveo7m (Compose) — attachment chip rules ===== */
  .files {
    flex: none;
  }

  .files {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-4);
  }

  .chip {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-badge);
    padding: var(--space-1) var(--space-3);
    font-size: var(--text-xs);
    min-block-size: var(--control-sm);
    max-width: 100%;
  }

  .fname {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chip small {
    color: var(--text-faint);
  }
</style>
